import { TimezoneSelect, TimezoneSelectProps } from '@mi-front/ui';
import { uniq } from 'lodash';
import { useStations } from '../../core/stations/hooks/useStations';

export const StationsTimezoneSelect = ({ ...rest }: TimezoneSelectProps) => {
  const stations = useStations();

  return <TimezoneSelect timezones={uniq(stations.map((s) => s.timezone))} {...rest} />;
};
